import React, { useEffect }  from 'react';

const ProductNavigation = ({ navigationEntries = [], moreLabel }) => {
	useEffect(() => {
		window.applicationReInit(['ProductNavBar']);
	}, []);

	return (
		<React.Fragment>
			{/* Navigation */}
			<div className="c-product-nav-bar__listitems js-toggle-product-nav__list">
				<ul className="c-product-nav-bar__navigation c-nav-product js-listitems">
				{navigationEntries && navigationEntries.map((item, index) => (
					<li key={index} className="c-nav-product__item">
					<a className="c-link c-nav-product__link" aria-label={item.label} href={item.targetUrl}>
						<span className="c-link__text">{item.label}</span>
					</a>
					</li>
				))}
				</ul>
			</div>
		
			{/* More Buttons */}
			<div className="c-product-nav-bar__more-link-container js-more-link-container">
				<div className="c-product-nav-bar__more-link">
					{/* eslint-disable-next-line */}
					<a className="c-link js-more-link c-nav-product__more-link" aria-label="More">
						<span className="c-link__text">{moreLabel}</span>
						<span aria-hidden="true" className="c-icon c-icon--chevron-down c-product-nav-bar__more-link-icon"></span>
					</a>
				</div>
				<div className='c-product-nav-bar__more-link-sub-menu js-sub-menu'>
				<div className="c-product-nav-bar__more-link">
					{/* eslint-disable-next-line */}
					<a className="c-link js-more-link c-nav-product__more-link" aria-label="More">
						<span className="c-link__text">{moreLabel}</span>
						<span aria-hidden="true" className="c-icon c-icon--chevron-up c-product-nav-bar__more-link-icon"></span>
					</a>
				</div>
				<div className="c-product-nav-bar__listitems">
					<ul className="c-product-nav-bar__navigation c-nav-product js-submenu-listitems"></ul>
				</div>
				</div>
			</div>
		</React.Fragment>
  )};
  
  export default ProductNavigation;